import { memo } from "react";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionConnection as Question } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection";

import type { FormOptionType } from "@/components/ui/form/_types/type";

import type { CheckedState } from "@radix-ui/react-checkbox";

type Props = {
	availableItemIDs: ForArrayType<string[]>;
	rawAvailableItemIDs: string[];
	nameAndIDOptions: FormOptionType[];
	onSetAvailableItemIDs: (_input: CheckedState, item: FormOptionType) => void;
};

export const QuestionPlanOptionConnection = memo(
	({ availableItemIDs, rawAvailableItemIDs, nameAndIDOptions, onSetAvailableItemIDs }: Props) => {
		return (
			<Question
				title="予約可能なオプション"
				guide="このプランで予約可能なオプションを選択しましょう。<br />※一覧には公開中のオプションと、このプランに紐づけ済みのオプションを表示します。紐づけ済みで非公開のものは先頭に【非公開】と付きます。"
				availableItemIDs={availableItemIDs}
				rawAvailableItemIDs={rawAvailableItemIDs}
				nameAndIDOptions={nameAndIDOptions}
				onSetAvailableItemIDs={onSetAvailableItemIDs}
			/>
		);
	},
);

QuestionPlanOptionConnection.displayName = "QuestionPlanOptionConnection";
